import { render } from "./List.vue?vue&type=template&id=067ea20a&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=067ea20a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-067ea20a"

export default script